// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2axJ9","name":"Header_name__1jboi","birthday":"Header_birthday__3uT8T","skeleton":"Header_skeleton__c5Rhb"};